import IconGeneral from "@icons/IconGeneral";
import IconOthers from "@icons/IconOthers";
import IconPerformanceV2 from "@icons/IconPerformanceV2";
import IconProfile from "@icons/IconProfile";
import IconProjectDelivery from "@icons/IconProjectDelivery";

export const filterFaqBTN = [
  {
    title: "Umum",
    valueBtn: "general",
    isSelected: false,
    icon: <IconGeneral />,
    path: 'umum'
  },
  {
    title: "Akun",
    valueBtn: "account",
    isSelected: false,
    icon: <IconProfile />,
    path: 'akun'
  },
  {
    title: "Performa",
    valueBtn: "performance",
    isSelected: false,
    icon: <IconPerformanceV2 />,
    path: 'performa'
  },
  {
    title: "Proses Proyek",
    valueBtn: "delivery",
    isSelected: false,
    icon: <IconProjectDelivery />,
    path: 'proses-proyek'
  },
  {
    title: "Lainnya",
    valueBtn: "others",
    isSelected: false,
    icon: <IconOthers />,
    path: 'lainnya'
  },
];